import { useCallback } from 'react';
import { chunkString } from '../actions/commentsActions/utils/chunkString';
import { maxCommentSize } from '../actions/commentsActions/constants';
import createFormDataArrOfAttachments from '../helpers/createFormDataArrOfAttachments';
import sendCommentToRequest from '../requests/sendCommentToRequest';
import addAttachmentsToComment from '../requests/addAttachmentsToRequestComment';
import { getRequestComments } from '../queries/useRequestComments';

const useSendRequestComment = () => {
  const sendComment = useCallback(
    async ({ comment, availableForClient = false, requestId, attachments }) => {
      const arrayOfComments = chunkString(comment, maxCommentSize);

      for (let item of arrayOfComments) {
        const data = {
          note: item ? item.replace(/"/g, '\\"') : '(Вложение)',
          availableForClient,
        };

        await sendCommentToRequest(requestId, data);
      }

      if (attachments.length) {
        const comments = await getRequestComments(requestId);

        const lastCommentId = comments[comments.length - 1].id;

        const formDataAttachments = createFormDataArrOfAttachments(attachments);

        await addAttachmentsToComment(lastCommentId, formDataAttachments);
      }
    },
    []
  );

  return sendComment;
};

export default useSendRequestComment;
